<div class="">
  <form [formGroup]="rfpForm" id="rfpForm" novalidate (ngSubmit)="onSubmit($event)">
    <section id="content">
      <div class="spinner-container" *ngIf="loading">
        <div class="spinner">
          <div class="sk-folding-cube">
            <div class="sk-cube1 sk-cube"></div>
            <div class="sk-cube2 sk-cube"></div>
            <div class="sk-cube4 sk-cube"></div>
            <div class="sk-cube3 sk-cube"></div>
          </div>
        </div>
      </div>

      <div class="external-tabs">
        <!-- <p-steps [model]="steps" [activeIndex]="index" [readonly]="true"></p-steps>-->

        <p-messages [escape]="true" [value]="msgs"></p-messages>
        <p-tabView [(activeIndex)]="index" (onChange)="onTabChange($event)">
          <!-- RFP Details Tab -->
          <p-tabPanel header="RFP Details" leftIcon="pi pi-info-circle">
            <div class="tab-content" [formGroup]="rfpForm">
              <div role="tabpanel" class="tab-pane in active" id="tab-1">
                <div class="card">
                  <div class="card-title">
                    <h2>{{ currentMode === 'add' ? 'Add RFP' : currentMode === 'edit' ? 'Edit RFP' : 'View RFP' }}</h2>
                  </div>
                  <div class="cont">
                    <div class="group">

                      <div class="collapse-title" (click)="toggleCollapse('rfpDetails')">
                        RFP Details
                        <i class="collapse-icon fa"></i>
                      </div>
                      <div class="collapse in show">
                        <div class="group-cont">
                          <div class="form-group">
                            <div class="row">
                              <!-- Customer Name -->
                              <div class="col-md-6 col-xs-12">
                                <div class="inputs">
                                  <p-dropdown id="customerName" formControlName="customerName" [options]="customers"
                                    [disabled]="isViewMode()" [optionDisabled]="isViewMode()" optionLabel="label"
                                    optionValue="value" [filter]="true" placeholder="Select Customer" [showClear]="true"
                                    class="full-width"></p-dropdown>
                                  <label for="customerName"><span class="required" style="color:coral">*</span> Customer
                                    Name</label>
                                  <div
                                    *ngIf="rfpForm.controls['customerName'].invalid && (rfpForm.controls['customerName'].dirty || rfpForm.controls['customerName'].touched)"
                                    class="alert alert-danger">
                                    <div *ngIf="rfpForm.controls['customerName'].errors?.required">Customer Name is
                                      required.</div>
                                  </div>
                                </div>
                              </div>


                              <!-- Deployment Type -->
                              <div class="col-md-6 col-xs-12">
                                <div class="inputs">
                                  <p-dropdown id="deploymentType" [options]="deploymentTypes"
                                    placeholder="Select Deployment Type" formControlName="deploymentType"
                                    [disabled]="isViewMode()" [optionDisabled]="isViewMode()"
                                    class="full-width"></p-dropdown>
                                  <label for="deploymentType"><span class="required" style="color:coral">*</span>
                                    Deployment Type</label>
                                  <div
                                    *ngIf="rfpForm.controls['deploymentType'].invalid && (rfpForm.controls['deploymentType'].dirty || rfpForm.controls['deploymentType'].touched)"
                                    class="alert alert-danger">
                                    <div *ngIf="rfpForm.controls['deploymentType'].errors?.required">Deployment Type is
                                      required.</div>
                                  </div>
                                </div>
                              </div>

                              <!-- Product Group -->
                              <div class="col-md-6 col-xs-12">
                                <div class="inputs">
                                  <p-dropdown id="productGroup" [options]="productGroups" formControlName="productGroup"
                                    [disabled]="isViewMode()" [optionDisabled]="isViewMode()"
                                    class="full-width"></p-dropdown>
                                  <label for="productGroup"><span class="required" style="color:coral">*</span> Product
                                    Group</label>
                                  <div
                                    *ngIf="rfpForm.controls['productGroup'].invalid && (rfpForm.controls['productGroup'].dirty || rfpForm.controls['productGroup'].touched)"
                                    class="alert alert-danger">
                                    <div *ngIf="rfpForm.controls['productGroup'].errors?.required">Product Group is
                                      required.</div>
                                  </div>
                                </div>
                              </div>

                              <!-- RFP Reference Number -->
                              <div class="col-md-6 col-xs-12">
                                <div class="inputs">
                                  <input id="rfpReferenceNumber" type="text" formControlName="rfpReferenceNumber"
                                    [readonly]="isViewMode()" class="full-width" />
                                  <label for="rfpReferenceNumber"><span class="required" style="color:coral">*</span>
                                    RFP Reference Number</label>
                                  <div
                                    *ngIf="rfpForm.controls['rfpReferenceNumber'].invalid && (rfpForm.controls['rfpReferenceNumber'].dirty || rfpForm.controls['rfpReferenceNumber'].touched)"
                                    class="alert alert-danger">
                                    <div *ngIf="rfpForm.controls['rfpReferenceNumber'].errors?.required">RFP Reference
                                      Number is required.</div>
                                  </div>
                                </div>
                              </div>

                              <!-- RFP Link -->
                              <div class="col-md-12 col-xs-12">
                                <div class="inputs">
                                  <input id="rfpLink" type="text" formControlName="rfpLink" [readonly]="isViewMode()"
                                    class="full-width" />
                                  <label for="rfpLink">RFP Link</label>
                                </div>
                              </div>



                              <!-- RFP Scope -->
                              <div class="col-md-6 col-xs-12">
                                <div class="inputs">
                                  <textarea id="rfpScope" formControlName="rfpScope" [readonly]="isViewMode()" rows="4"
                                    class="full-width"></textarea>
                                  <label for="rfpScope">RFP Scope</label>
                                </div>
                              </div>

                              <!-- RFP Scope Details -->
                              <div class="col-md-6 col-xs-12">
                                <div class="inputs">
                                  <textarea id="rfpScopeDetails" formControlName="rfpScopeDetails"
                                    [readonly]="isViewMode()" rows="4" class="full-width"></textarea>
                                  <label for="rfpScopeDetails">RFP Scope Details</label>
                                </div>
                              </div>

                              <!-- RFP Tags -->
                              <div class="col-md-6 col-xs-12">
                                <div class="inputs">
                                  <p-chips id="tags" class="tagsChips" formControlName="tags" [readonly]="isViewMode()"
                                    [disabled]="isViewMode()" [allowDuplicate]="false"></p-chips>
                                  <label for="tags">RFP Tags</label>
                                </div>
                              </div>

                              <!-- Tech Consultant -->
                              <div class="col-md-6 col-xs-12">
                                <div class="inputs">
                                  <p-dropdown id="techConsultant" formControlName="techConsultant" [options]="techLeads"
                                    [disabled]="isViewMode()" [optionDisabled]="isViewMode()" optionLabel="label"
                                    optionValue="value" placeholder="Select Tech Consultant" [filter]="true"
                                    [showClear]="true" class="full-width"></p-dropdown>
                                  <label for="techConsultant"><span class="required" style="color:coral">*</span> Tech
                                    Consultant</label>
                                  <div
                                    *ngIf="rfpForm.controls['techConsultant'].invalid && (rfpForm.controls['techConsultant'].dirty || rfpForm.controls['techConsultant'].touched)"
                                    class="alert alert-danger">
                                    <div *ngIf="rfpForm.controls['techConsultant'].errors?.required">Tech Consultant is
                                      required.</div>
                                  </div>
                                </div>
                              </div>

                              <!-- Inquiry Date -->
                              <div class="col-md-6 col-xs-12">
                                <div class="inputs">
                                  <p-calendar id="inquiryDate" formControlName="inquiryDate" [disabled]="isViewMode()"
                                    [showIcon]="true" class="full-width"></p-calendar>
                                  <label for="inquiryDate"><span class="required" style="color:coral">*</span> Inquiry
                                    Date</label>
                                  <div
                                    *ngIf="rfpForm.controls['inquiryDate'].invalid && (rfpForm.controls['inquiryDate'].dirty || rfpForm.controls['inquiryDate'].touched)"
                                    class="alert alert-danger">
                                    <div *ngIf="rfpForm.controls['inquiryDate'].errors?.required">Inquiry Date is
                                      required.</div>
                                  </div>
                                </div>
                              </div>

                              <!-- Submission Date -->
                              <div class="col-md-6 col-xs-12">
                                <div class="inputs">
                                  <p-calendar id="submissionDate" formControlName="submissionDate"
                                    [disabled]="isViewMode()" [showIcon]="true" class="full-width"></p-calendar>
                                  <label for="submissionDate"><span class="required" style="color:coral">*</span>
                                    Submission Date</label>
                                  <div
                                    *ngIf="rfpForm.controls['submissionDate'].invalid && (rfpForm.controls['submissionDate'].dirty || rfpForm.controls['submissionDate'].touched)"
                                    class="alert alert-danger">
                                    <div *ngIf="rfpForm.controls['submissionDate'].errors?.required">Submission Date is
                                      required.</div>
                                  </div>
                                </div>
                              </div>

                              <!-- Project Duration -->
                              <div class="col-md-6 col-xs-12">
                                <div class="inputs">
                                  <div class="row">
                                    <div class="col-md-5 col-xs-12">
                                      <p-inputNumber id="projectDuration" formControlName="projectDuration"
                                        [readonly]="isViewMode()" class="full-width" />
                                    </div>
                                    <div class="col-md-7 col-xs-12">
                                      <p-dropdown id="durationUnit" [options]="['Years', 'Months']"
                                        formControlName="durationUnit" [disabled]="isViewMode()"
                                        class="full-width"></p-dropdown>
                                    </div>
                                  </div>
                                  <label for="projectDuration"><span class="required" style="color:coral">*</span>
                                    Project Duration</label>
                                  <div
                                    *ngIf="rfpForm.controls['projectDuration'].invalid && (rfpForm.controls['projectDuration'].dirty || rfpForm.controls['projectDuration'].touched)"
                                    class="alert alert-danger">
                                    <div *ngIf="rfpForm.controls['projectDuration'].errors?.required">Project Duration
                                      is required.</div>
                                  </div>
                                </div>
                              </div>

                              <!-- Location -->
                              <div class="col-md-6 col-xs-12">
                                <div class="inputs">
                                  <input id="location" type="text" formControlName="location" [readonly]="isViewMode()"
                                    class="full-width" />
                                  <label for="location"><span class="required" style="color:coral">*</span>
                                    Location</label>
                                  <div
                                    *ngIf="rfpForm.controls['location'].invalid && (rfpForm.controls['location'].dirty || rfpForm.controls['location'].touched)"
                                    class="alert alert-danger">
                                    <div *ngIf="rfpForm.controls['location'].errors?.required">Location is required.
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Initial Bid Bond -->
                              <div class="col-md-6 col-xs-12">
                                <div class="inputs">
                                  <p-inputNumber id="initialBidBond" formControlName="initialBidBond"
                                    [readonly]="isViewMode()" class="full-width" />
                                  <label for="initialBidBond"><span class="required" style="color:coral">*</span>
                                    Initial Bid Bond (%)</label>
                                  <div
                                    *ngIf="rfpForm.controls['initialBidBond'].invalid && (rfpForm.controls['initialBidBond'].dirty || rfpForm.controls['initialBidBond'].touched)"
                                    class="alert alert-danger">
                                    <div *ngIf="rfpForm.controls['initialBidBond'].errors?.required">Initial Bid Bond is
                                      required.</div>
                                  </div>
                                </div>
                              </div>

                              <!-- Final Bid Bond -->
                              <div class="col-md-6 col-xs-12">
                                <div class="inputs">
                                  <p-inputNumber id="finalBidBond" formControlName="finalBidBond"
                                    [readonly]="isViewMode()" class="full-width" />
                                  <label for="finalBidBond"><span class="required" style="color:coral">*</span> Final
                                    Bid Bond (%)</label>
                                  <div
                                    *ngIf="rfpForm.controls['finalBidBond'].invalid && (rfpForm.controls['finalBidBond'].dirty || rfpForm.controls['finalBidBond'].touched)"
                                    class="alert alert-danger">
                                    <div *ngIf="rfpForm.controls['finalBidBond'].errors?.required">Final Bid Bond is
                                      required.</div>
                                  </div>
                                </div>
                              </div>

                              <!-- Resources -->
                              <div class="col-md-3 col-xs-12">
                                <div class="inputs-select">
                                  <div class="input-checkbox">
                                    <input type="checkbox" name="" id="resources" formControlName="resources"
                                      [ngModelOptions]="{standalone: true}" [disabled]="isViewMode()" />
                                    <span></span>
                                  </div>
                                  <label class="label-checkbox" for="resources">Resources</label>
                                </div>
                              </div>

                              <!-- License -->
                              <div class="col-md-3 col-xs-12">
                                <div class="inputs-select">
                                  <div class="input-checkbox">
                                    <input type="checkbox" name="" id="license" formControlName="license"
                                      [ngModelOptions]="{standalone: true}" [disabled]="isViewMode()" />
                                    <span></span>
                                  </div>
                                  <label class="label-checkbox" for="license">License Available</label>
                                </div>
                              </div>

                              <!-- Training -->
                              <div class="col-md-3 col-xs-12">
                                <div class="inputs-select">
                                  <div class="col-md-12 col-xs-12">
                                    <div class="input-checkbox">
                                      <input type="checkbox" name="" id="training" formControlName="training"
                                        [ngModelOptions]="{standalone: true}" [disabled]="isViewMode()"
                                        (change)="toggleTrainingDetails()" />
                                      <span></span>
                                    </div>
                                    <label class="label-checkbox" for="training">Training Available</label>
                                  </div>
                                  <div class=" ">
                                    <div *ngIf="rfpForm.get('training').value">
                                      <div class="col-md-12 col-xs-12">
                                        <div class="col-md-12 col-xs-12">
                                          <label class="col-md-12 col-xs-12 label-checkbox"
                                            for="trainingDescription">Training Details</label>
                                          <div class="  col-md-12 col-xs-12">
                                            <input id="trainingDescription" type="text"
                                              formControlName="trainingDescription" [readonly]="isViewMode()"
                                              class="input-text-check full-width col-md-12 col-xs-12" />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>

                              <!-- Support -->
                              <div class="col-md-3 col-xs-12">
                                <div class="inputs-select">
                                  <div class="col-md-12 col-xs-12">
                                    <div class="input-checkbox">
                                      <input type="checkbox" name="" id="support" formControlName="support"
                                        [ngModelOptions]="{standalone: true}" [disabled]="isViewMode()"
                                        (change)="toggleSupportDetails()" />
                                      <span></span>
                                    </div>
                                    <label class="label-checkbox" for="support">Support Available</label>

                                  </div>
                                  <div class=" ">
                                    <div *ngIf="rfpForm.get('support').value">
                                      <div class="col-md-12 col-xs-12">
                                        <div class="col-md-12 col-xs-12">

                                          <div class="row">
                                            <label class="col-md-12 col-xs-12 label-checkbox"
                                              for="supportDuration">Support Duration</label>
                                            <div class="col-md-5 col-xs-12">
                                              <p-inputNumber id="supportDuration" formControlName="supportDuration"
                                                [readonly]="isViewMode()"></p-inputNumber>
                                            </div>
                                            <div class="col-md-7 col-xs-12">
                                              <p-dropdown id="supportDurationUnit" appendTo="body"
                                                [options]="['Years', 'Months']" formControlName="supportDurationUnit"
                                                [disabled]="isViewMode()" class="full-width"></p-dropdown>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-12 col-xs-12">

                                              <div class="inputs">
                                                <label class="label-checkbox  " for="supportDescription">Support
                                                  Description</label>
                                                <input id="supportDescription col-md-12 col-xs-12" type="text"
                                                  formControlName="supportDescription" [readonly]="isViewMode()"
                                                  class="full-width" />

                                              </div>
                                            </div>
                                          </div>

                                        </div>

                                      </div>


                                    </div>
                                  </div>

                                </div>
                              </div>

                              <!-- Summary -->
                              <div class="col-md-12 col-xs-12">
                                <div class="inputs">
                                  <textarea id="summary" formControlName="summary" [readonly]="isViewMode()" rows="4"
                                    class="full-width"></textarea>
                                  <label for="summary">Summary</label>
                                </div>
                              </div>
                              <!-- Attach RFP Files -->
                              <div class="col-md-12 col-xs-12">
                                <div class="inputs">

                                  <!-- Display Uploaded Files -->
                                  <div class="col-md-12 col-xs-12" *ngIf="uploadedFiles.length > 0">
                                    <div class=" ">
                                      <ul>
                                        <li *ngFor="let file of uploadedFiles">
                                          <p-button (click)="downloadAttachment(file)" label="{{file.attachmentName}}"
                                            icon="pi pi-download" size="small" [link]="true"   />
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <p-fileUpload id="rfpFiles" name="rfpFiles" [disabled]="isViewMode()"
                                    multiple="multiple" customUpload="true" (uploadHandler)="onUpload($event)"
                                    class="full-width">
                                  </p-fileUpload>
                                  <label for="rfpFiles">Attach RFP Files</label>
                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-controls">
              <button pButton label="Next" (click)="nextTab()" *ngIf="index < steps.length - 1"></button>
            </div>
            <div class="wizard-cotroles">
              <div *ngIf="!isViewMode()" class="form-actions">
                <button id="finish" pButton label="Submit"></button>
              </div>
              <p>2 Of 3</p>
              <!-- <div class="control prev" data-target="tab-1" (click)="openPrevious(1)">Prev</div> -->
            </div>
          </p-tabPanel>

          <!-- Q&A Tab -->
          <p-tabPanel header="Q&A" leftIcon="pi pi-question-circle">
            <div role="tabpanel" class="tab-pane" id="tab-2">
              <div class="card">
                <div class="card-title">
                  <h2>Q&A</h2>
                </div>
                <div class="cont">
                  <div class="group">
                    <button pButton label="Ask a Question" type="button" style="margin-bottom: 10px;"
                      (click)="showAddQuestionDialog()" *ngIf="!isViewMode()"></button>
                    <button pButton label="Add Existing Question" type="button"
                      style="margin-bottom: 10px; margin-left: 10px;" (click)="showAddQuestionIdDialog()"
                      *ngIf="!isViewMode()"></button>
                    <p-table [value]="qaList" [paginator]="true" [rows]="10">
                      <ng-template pTemplate="header">
                        <tr>
                          <th>Number</th>
                          <th>Category</th>
                          <th>Question</th>
                          <th>Answer</th>
                          <th *ngIf="!isViewMode()">Actions</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-qa let-i="rowIndex">
                        <tr>
                          <td>{{ i + 1 }}</td>
                          <td>{{ qa.category }}</td>
                          <td>{{ qa.question }}</td>
                          <td>{{ qa.answer }}</td>
                          <td *ngIf="!isViewMode()">
                            <button pButton type="button" icon="pi pi-pencil" class="p-button-rounded p-button-text"
                              (click)="showEditQuestionDialog(qa)"></button>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-controls">
              <button pButton label="Previous" (click)="previousTab()" *ngIf="index > 0" style="margin-right: 10px;"></button>
              <button pButton label="Next" (click)="nextTab()" *ngIf="index < steps.length - 1"></button>
            </div>
          </p-tabPanel>

          <!-- Comments Tab -->

          <!-- Comments Tab -->
          <!-- Comments Tab -->
          <p-tabPanel header="Comments" leftIcon="pi pi-list">
            <div role="tabpanel" class="tab-pane" id="tab-2">
              <!-- Latest Comments -->
              <div class="card">
                <div class="card-title">
                  <h2>Latest Comments</h2>
                </div>

                <div class="cont">
                  <ul id="userComments" class="latest-comments">
                    <li *ngFor="let comment of comments; let i = index">
                      <div class="cont-img">
                        <img src="" alt="">
                      </div>
                      <div class="cont-txt">
                        <h3>{{comment.title}}</h3>
                        <h4>
                          <pre>{{comment.content}}</pre>
                        </h4>
                        <p class="text-sm text-gray-500 mt-2"> Posted by: {{comment.commentBy }}</p>
                        <span class="date">
                          {{ comment?.commentLocalDateTime | date:'EEE, MM/dd/yyyy' }},
                          {{ comment?.commentLocalDateTime | date:'hh:mm a' }}
                        </span>

                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- Add Comment -->
              <div class="card" *ngIf="!isViewMode()">
                <div class="card-title">
                  <h2>Add Comment</h2>
                </div>
                <div class="cont">
                  <div class="add-comment">
                    <div class="form-group">
                      <div class="inputs" id="addComment">
                        <input type="text" id="commentTitle" placeholder="Comment Title" [(ngModel)]="newCommentTitle"
                          [ngModelOptions]="{standalone: true}" />
                        <textarea id="commentDescription" cols="30" rows="10" placeholder="Comment Details"
                          [(ngModel)]="newCommentDescription" [ngModelOptions]="{standalone: true}"></textarea>
                      </div>
                    </div>
                    <div class="form-actions">
                      <button id="post" pButton label="Post" (click)="addComment()"
                        [disabled]="!newCommentTitle?.trim() || !newCommentDescription?.trim()"></button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Navigation Controls -->
           
            </div>

            <div class="wizard-controls">
                <button pButton label="Previous" (click)="previousTab()" *ngIf="index > 0" style="margin-right: 10px;"></button>
              <button pButton label="Next" (click)="nextTab()" *ngIf="index < steps.length - 1"></button>

              <div class="wizard-cotroles">
                <div *ngIf="!isViewMode()" class="form-actions">
                  <button id="finish" pButton label="Finish"></button>
                </div>
                <p>2 Of 3</p>
                <!-- <div class="control prev" data-target="tab-1" (click)="openPrevious(1)">Prev</div> -->
              </div>
            </div>
          </p-tabPanel>


          <!-- History Tab -->
          <p-tabPanel header="History" leftIcon="pi pi-history">
            <div role="tabpanel" class="tab-pane" id="tab-4">
              <div class="card">
                <div class="card-title">
                  <h2>Audit History</h2>
                </div>
                <div class="cont">
                  <p-table [value]="auditHistory" [paginator]="true" [rows]="10">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Action</th>
                        <th>Action Type</th>
                        <th>User</th>
                        <th>Date/Time</th>
                        <th>Description</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-audit>
                      <tr>
                        <td>{{audit.action}}</td>
                        <td>{{audit.actionType}}</td>
                        <td>{{audit.actionUserName}}</td>
                        <td>{{audit.actionDateTime | date:'medium'}}</td>
                        <td>{{audit.actionDescription}}</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
            <div class="wizard-controls">
              <button pButton label="Previous" (click)="previousTab()" *ngIf="index > 0 "></button>
            </div>
          </p-tabPanel>
        </p-tabView>
      </div>
    </section>
  </form>
</div>


<!-- Add this modal HTML near the Q&A tab section -->
<!-- Add this dialog near the Q&A tab section -->
<p-dialog header="Add New Question" [(visible)]="displayDialog" [modal]="true" [style]="{width: '50vw'}"
  [baseZIndex]="10000">
  <form id="qaForm">
    <div class="mb-3">
      <label for="category" class="label-text-dialog form-label">Category</label>
      <input id="category" type="text" class="form-control" [(ngModel)]="newCategory"
        [ngModelOptions]="{standalone: true}" placeholder="Enter category">
    </div>
    <div class="mb-3">
      <label for="question" class="label-text-dialog form-label">Question</label>
      <textarea id="question" class="form-control" rows="3" [(ngModel)]="newQuestion"
        [ngModelOptions]="{standalone: true}"></textarea>
    </div>
    <div class="mb-3">
      <label for="answer" class="label-text-dialog form-label">Answer</label>
      <textarea id="answer" class="form-control" rows="3" [(ngModel)]="newAnswer"
        [ngModelOptions]="{standalone: true}"></textarea>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="pi pi-times" label="Close" (click)="displayDialog = false"
      class="p-button-text"></button>
    <button type="button" pButton icon="pi pi-check" label="Add Q&A" (click)="addQnA()"></button>
  </ng-template>
</p-dialog>
<p-dialog header="Edit Answer" [(visible)]="displayEditDialog" [modal]="true" [style]="{width: '50vw'}"
  [baseZIndex]="10000">
  <form id="editQaForm">
    <div class="mb-3">
      <label for="editCategory" class="label-text-dialog form-label">Category</label>
      <input id="editCategory" type="text" class="form-control" [value]="editCategory" [disabled]="true" readonly>
    </div>
    <div class="mb-3">
      <label for="editQuestion" class="label-text-dialog form-label">Question</label>
      <textarea id="editQuestion" class="form-control" rows="3" [value]="editQuestion" [disabled]="true"
        readonly></textarea>
    </div>
    <div class="mb-3">
      <label for="editAnswer" class="label-text-dialog form-label">Answer</label>
      <textarea id="editAnswer" class="form-control" rows="3" [(ngModel)]="editAnswer"
        [ngModelOptions]="{standalone: true}"></textarea>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="pi pi-times" label="Close" (click)="displayEditDialog = false"
      class="p-button-text"></button>
    <button type="button" pButton icon="pi pi-check" label="Save" (click)="saveEditedQnA()"></button>
  </ng-template>
</p-dialog>
<p-dialog header="Add Existing Question" [(visible)]="displayQuestionIdDialog" [modal]="true" [style]="{width: '50vw'}"
  [baseZIndex]="10000">
  <form id="questionIdForm">
    <div class="mb-3">
      <label for="categoryDropdown" class="label-text-dialog form-label">Category</label>
      <p-dropdown id="categoryDropdown" [options]="questionCategories" [(ngModel)]="selectedCategory"
        [ngModelOptions]="{standalone: true}" placeholder="Select Category"
        (onChange)="onCategoryChange($event)"></p-dropdown>
    </div>
    <div class="mb-3">
      <label for="questionMultiSelect" class="label-text-dialog form-label">Questions</label>
      <p-multiSelect id="questionMultiSelect" appendTo="body" [options]="filteredQuestions"
        [(ngModel)]="selectedQuestions" [ngModelOptions]="{standalone: true}" optionLabel="question"
        placeholder="Select Questions" [disabled]="!selectedCategory"></p-multiSelect>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="pi pi-times" label="Close" (click)="displayQuestionIdDialog = false"
      class="p-button-text"></button>
    <button type="button" pButton icon="pi pi-check" label="Add Questions"
      (click)="addQuestionsWithoutAnswers()"></button>
  </ng-template>
</p-dialog>
<p-toast></p-toast>